function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.05697 10.04C2.56697 10.55 3.37697 10.6 3.92697 10.14C8.59697 6.3 15.377 6.3 20.057 10.13C20.617 10.59 21.437 10.55 21.947 10.04C22.537 9.45 22.497 8.47 21.847 7.94C16.137 3.27 7.87697 3.27 2.15697 7.94C1.50697 8.46 1.45697 9.44 2.05697 10.04ZM9.81697 17.8L11.287 19.27C11.677 19.66 12.307 19.66 12.697 19.27L14.167 17.8C14.637 17.33 14.537 16.52 13.937 16.21C12.717 15.58 11.257 15.58 10.027 16.21C9.45697 16.52 9.34697 17.33 9.81697 17.8ZM7.91697 14.2C7.34697 14.61 6.57697 14.56 6.08697 14.07C5.47697 13.46 5.51697 12.45 6.20697 11.95C9.65697 9.46 14.347 9.46 17.787 11.95C18.477 12.44 18.517 13.46 17.917 14.06L17.907 14.07C17.417 14.56 16.647 14.6 16.077 14.2C13.637 12.47 10.357 12.47 7.91697 14.2Z",
  fill: "#98A7B8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.81697 17.8L11.287 19.27C11.677 19.66 12.307 19.66 12.697 19.27L14.167 17.8C14.637 17.33 14.537 16.52 13.937 16.21C12.717 15.58 11.257 15.58 10.027 16.21C9.45697 16.52 9.34697 17.33 9.81697 17.8Z",
  fill: "#DE106B"
});

function SvgNetworkNo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkNo);
export default __webpack_public_path__ + "static/media/network-no.d7d6aa91.svg";
export { ForwardRef as ReactComponent };